import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { DatePipe, NgForOf, NgIf } from '@angular/common';
import { LetDirective } from '@ngrx/component';
import { PartnersComponent } from './partners/partners.component';
import {
  MediaPressKit,
  NodeProject,
  TermAward,
} from '@madeinlune/massaud-types';
import { InfosComponent } from '@nx-massaud/detail/ui/common';
import { ParagraphsComponent } from '@madeinlune/paragraphs/root';
import {
  ParagraphClaim,
  ParagraphLayout,
  ParagraphMediaGallery,
  ParagraphText,
} from '@madeinlune/massaud-types';

@Component({
  selector: 'msd-det-ui-project',
  standalone: true,
  template: `
    <ng-container *ngIf="project">
      <section class="b-cover">
        <ng-content select=".media-gallery"></ng-content>
      </section>
      <section class="b-contents">
        <section class="b-title-features-infos">
          <h1 [innerHTML]="project.title"></h1>
          <section class="b-features">
            <ng-content select=".features"></ng-content>
          </section>
          <section class="b-infos">
            <msd-det-ui-infos
              [pressKit]="pressKit"
              [awards]="awards"
              [description]="project.description"
            ></msd-det-ui-infos>
          </section>
        </section>
        <section class="b-media">
          <ng-content select=".media"></ng-content>
        </section>
        <ng-container *ngIf="paragraphs">
          <mil-paragraphs [paragraphs]="paragraphs"></mil-paragraphs>
        </ng-container>
        <section class="b-associated">
          <ng-content select=".associated"></ng-content>
        </section>
      </section>
    </ng-container>
  `,
  styleUrls: ['./project.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgIf,
    LetDirective,
    NgForOf,
    PartnersComponent,
    DatePipe,
    InfosComponent,
    ParagraphsComponent,
  ],
})
export class ProjectComponent {
  @Input()
  project: NodeProject | undefined;
  @Input()
  pressKit: MediaPressKit | undefined;
  @Input()
  awards: TermAward[] | undefined;
  @Input()
  paragraphs:
    | (
        | ParagraphText
        | ParagraphLayout
        | ParagraphMediaGallery
        | ParagraphClaim
      )[]
    | undefined;
}
